import { z } from 'zod';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowSchedulingBlockConfigSchema = z.object({
    practiceIds: z.array(z.string()).min(1, { message: 'At least one practice ID is required' }),
    providerUserIds: z.array(z.string()).optional(),
    appointmentTypes: z
        .array(z.string())
        .min(1, { message: 'At least one appointment type is required' }),
});
export const FlowSchedulingBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.Scheduling),
    config: FlowSchedulingBlockConfigSchema,
});
//# sourceMappingURL=config.js.map